// libs
import { createContext, useContext } from 'react';

// types
import { EditorContextProps } from '../PlainEditor/types';

export const EditorContext = createContext<EditorContextProps | null>(null);

export const useEditorDetails = () => {
  const value = useContext(EditorContext);

  if (!value) {
    throw new Error('[EditorContext] Not initialised');
  }

  return value;
};
